import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";

@Component({
  selector: 'app-new-pagination',
  templateUrl: './new-pagination.component.html',
  styleUrls: ['./new-pagination.component.scss']
})
export class NewPaginationComponent implements OnInit, OnChanges {
  @Input() currentPage = 1;
  @Input() totalItems = 0;
  @Input() itemsPerPage = 10;
  @Input() maxPagesToShow = 5;

  @Output() pageChange = new EventEmitter<number>();
isRtl = false;

  totalPages = 0;
  pages: number[] = [];

  ngOnInit(): void {
    this.calculatePages();
    
  }

  ngOnChanges(): void {
  this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    this.generatePages();  }

  calculatePages() {
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    this.generatePages();
  }

 generatePages(): void {
    this.pages = [];

    if (this.totalPages <= 1) return;

    const half = Math.floor(this.maxPagesToShow / 2);

    let start = this.currentPage - half;
    let end = this.currentPage + half;

    if (start < 1) {
      start = 1;
      end = Math.min(this.maxPagesToShow, this.totalPages);
    }

    if (end > this.totalPages) {
      end = this.totalPages;
      start = Math.max(end - this.maxPagesToShow + 1, 1);
    }

    for (let i = start; i <= end; i++) {
      this.pages.push(i);
    }
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.pageChange.emit(page);
  }

  prev(): void {
    this.goToPage(this.currentPage - 1);
  }

  next(): void {
    this.goToPage(this.currentPage + 1);
  }

}
